import styled from "@emotion/styled";
import { Typography } from "@mui/material";
import * as React from "react";

const StyledTypography = styled(Typography)`
  color: ${(props) => {
    switch (props.status) {
      case "approved":
        return "#512879";
      case "accepted":
        return "#512879";
      case "pending":
        return "#000000";
      case "paid":
        return "#512879";
      case "partially-paid":
        return "#512879";
      case "rejected":
        return "red";
      case "canceled":
        return "red";
      case "completed":
        return "#512879";
      default:
        return "black";
    }
  }};
  font-size: 14px;
`;

const InvoiceStatusLable = ({ row, component }) => {
  if (!row.status) {
    return null;
  }

  return (
    <StyledTypography status={row.status.keyword}>
      {row.status.keyword === "pending" ? "Invoice Sent" : row.status.name}
    </StyledTypography>
  );
};

export default InvoiceStatusLable;
